import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';
import classNames from 'classnames';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';
import { getPromptCodeList } from '../../../SetUp/promptCodes/actions/PromptCodeActions';
import { getSkillAcquisitionCollectedTADataByTargetIDAction, deleteSkillAcqCollectedTAData, updateSkillAcqCollectedTADataPromtCodeAction, updateSkillAcaCollectedTADataAction } from './actions/skillAquisitionTargetActions';
import { renderCheckBox, renderAutoCompleteSingleSelect, renderDateField, renderTimePicker } from '../../../../../../../components/reduxFields';
import { CancelButton } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';
import PaginatorCustom from '../../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../../components/SortingCustom';


const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

class RawDataTAModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId,
            targetId: props.targetId,
            skillsAcquisitionProgramId: props.skillsAcquisitionProgramId,
            selectedTargetIds: [],
            sessionDate: [],
            sessionTime: [],
        };
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
        let searchObj = {
            contain_filters: { patientId: this.state.patientId || null },
            pageNumber: 1,
        };
        this.props.getPromptCodeList(searchObj);
    }

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
        if (nextProps.skillAcqCollectedTADataBytTargetId && nextProps.skillAcqCollectedTADataBytTargetId.data) {
            
            let sessionDate1 = this.state.sessionDate;
            let sessionTime1 = this.state.sessionTime;
           (nextProps.skillAcqCollectedTADataBytTargetId.data || []).forEach((obj, index) => {
               _.update(sessionDate1, `[${obj.id}]`, function(n) {
                   return moment(obj.sessionDate).format('MM-DD-YYYY');
               });
               this.props.dispatch(change('RawDataTAModalForm', `Target[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY')  || null));

               _.update(sessionTime1, `[${obj.id}]`, function(n) {                    
                   return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
               });
               this.props.dispatch(change('RawDataTAModalForm', `Target[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
           });
            this.setState({sessionDate: sessionDate1, sessionTime: sessionTime1 });

             (nextProps.skillAcqCollectedTADataBytTargetId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataTAModalForm', `Target[${index}].id`, obj.staffId || null));
            });

            (nextProps.skillAcqCollectedTADataBytTargetId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataTAModalForm', `Target[${index}].status`, obj.statusId || null));
            });
            (nextProps.skillAcqCollectedTADataBytTargetId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataTAModalForm', `Target[${index}].promptCode`, obj.promptCodeId || null));
            });
        }
    }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.props.getSkillAcquisitionCollectedTADataByTargetIDAction(this.state.patientId, this.state.targetId, this.state.skillsAcquisitionProgramId, searchObj);
    }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }


    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    onDateChange = (input, value, targetId, action) => {
        input.onChange(moment(value).format());

        let sessionDate1 = this.state.sessionDate;     

        _.update(sessionDate1, `[${targetId}]`, function(n) {
            return moment(value).format('YYYY-MM-DD');
        });      
    
        this.setState({
            sessionDate: sessionDate1,           
        }, ()=>{
            let sessionDate =  moment(this.state.sessionDate[targetId]).format('YYYY-MM-DD') + 'T' + moment(this.state.sessionTime[targetId]).format('HH:mm:ss');            
            this.props.updateSkillAcaCollectedTADataAction(targetId, sessionDate, 0, 0, this.state.patientId, this.state.skillsAcquisitionProgramId, this.state.targetId, action)
        });
    }

    onTimeChange = (input, value, targetId, action) => {
        input.onChange(moment(value).format());
       
        let sessionTime1 = this.state.sessionTime;

        _.update(sessionTime1, `[${targetId}]`, function(n) {
            return  moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });
    
        this.setState({          
            sessionTime: sessionTime1,
        }, ()=>{
            let sessionDate =  moment(this.state.sessionDate[targetId]).format('YYYY-MM-DD') + 'T' + moment(this.state.sessionTime[targetId]).format('HH:mm:ss');            
            this.props.updateSkillAcaCollectedTADataAction(targetId, sessionDate, 0, 0, this.state.patientId, this.state.skillsAcquisitionProgramId, this.state.targetId, action)
        });
    }

    handleNewRequestStatus = (input, selectedRecord, targetId, action) => {
        input.onChange(selectedRecord.value);
        this.props.updateSkillAcaCollectedTADataAction(targetId, moment().format('YYYY-MM-DDTHH:mm:ss') , selectedRecord.value, selectedRecord.value, this.state.patientId, this.state.skillsAcquisitionProgramId, this.state.targetId, action)
    };
   
    handleNewRequestpromtCode = (input, selectedRecord, targetId) => {
        input.onChange(selectedRecord.value);
        this.props.updateSkillAcqCollectedTADataPromtCodeAction(targetId, selectedRecord.value, this.state.patientId, this.state.skillsAcquisitionProgramId, this.state.targetId)
    };


    handleDeleteTarget = () => {
        this.props.deleteSkillAcqCollectedTAData(this.state.selectedTargetIds, this.state.patientId, this.state.skillsAcquisitionProgramId, this.state.targetId)
        this.setState({
            selectedTargetIds : []
        }, () => {
            this.loadData();
        });
    }

    checkAllTargets = (e) => {
        let isTargetChecked = e.target.checked;
        let tragetData = this.props.skillAcqCollectedTADataBytTargetId.data !== undefined && this.props.skillAcqCollectedTADataBytTargetId.data;
        let selectedTargetIds = [];
        tragetData.forEach((obj, index) => {
            let targetIdCheck = `CheckTarget[${obj.id}${index}].Chk`;
            if (obj && isTargetChecked) {
                selectedTargetIds.push(obj.id);
                this.props.dispatch(change('RawDataTAModalForm', targetIdCheck, true));
            } else {
                this.props.dispatch(change('RawDataTAModalForm', targetIdCheck, false));
            }
        })
        this.setState({
            selectedTargetIds: selectedTargetIds,
        });
    }

    checkTargets = (e, index, obj) => {
        let selectedTargetIds = this.state.selectedTargetIds;
        let isTargetChecked = e.target.checked;
        if (isTargetChecked) {
            if (obj.id) {
                selectedTargetIds.push(obj.id);
            }
        } else {
            if (obj.id) {
                index = selectedTargetIds.findIndex((value) => value === obj.id);
                if (index >= 0) {
                    selectedTargetIds.splice(index, 1);
                }
            }
        }
        this.setState({
            selectedTargetIds: selectedTargetIds
        });
    }

    renderaData = (RawTADataList) => {
        RawTADataList = RawTADataList || [];

        if (!RawTADataList.length) {
            return (
                <tr>
                    <td colSpan="6">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return RawTADataList.map((data, index) => {
            return (
                <tr key={index}>
                    {/* <td>{moment(data.sessionDate).format('MM/DD/YYYY HH:mm:ss A')}</td>
                    <td>{data.staffName}</td> */}
                    <td>
                        <Field
                        name={`Target[${index}].sessionDate`}
                        //placeholder="Session Date"
                        locale="en-US"
                        selected={data.sessionDate}
                        //selected={this.state.sessionDate[data.id]}       
                        onDateChange={(input, value) => this.onDateChange(input, value, data.id, 'SESSIONDATE')}                       
                        openToYearSelection={true}
                        component={renderDateField} />
                    </td>                   
                    <td>
                        <Field
                            name={`Target[${index}].sessionTime`}
                            //placeholder="Time"
                            fullWidth={true}            
                            selected={this.state.sessionTime[data.id]}                       
                            component={renderTimePicker}
                            onDateChange={(input, value) => this.onTimeChange(input, value, data.id, 'SESSIONDATE')}                                      
                        />
                    </td>
                    <td>
                        <Field
                            name={`Target[${index}].id`}
                            hintText="Staff Name"
                            handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, data.id, 'STAFFID')}
                            options={this.props.allStaffs}
                            component={renderAutoCompleteSingleSelect}
                        />
                    </td>
                    <td>{data.taskName}</td>
                    <td>
                        <Field
                            name={`Target[${index}].status`}
                            hintText="Status"
                            handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, data.id, 'STATUS')}
                            options={this.props.masterTargetStatusWithoutReady}
                            component={renderAutoCompleteSingleSelect}
                        />
                    </td>
                    <td>
                        <Field
                            name={`Target[${index}].promptCode`}
                            hintText="Prompt Code"
                            handleNewRequest={(input, selectedValue) => this.handleNewRequestpromtCode(input, selectedValue, data.id)}
                            options={this.props.promptCodeListData.data}
                            component={renderAutoCompleteSingleSelect}
                        />
                    </td>
                    <td>
                        <div className="table_custom-check">
                            <Field
                                name={`CheckTarget[${data.id}${index}].Chk`}
                                component={renderCheckBox}
                                onChange={(e) => this.checkTargets(e, index, data)}
                                style={stylescss.checkbox}
                            />
                        </div>
                    </td>
                </tr>
            );
        });
    }

    render() {
        const { skillAcqCollectedTADataBytTargetId } = this.props,
            RawTADataList = (skillAcqCollectedTADataBytTargetId && skillAcqCollectedTADataBytTargetId.data) || [],
            RawTADataListMeta = (skillAcqCollectedTADataBytTargetId && skillAcqCollectedTADataBytTargetId.meta) || null;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.bordered,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
            'suptable': true,
        });
        const actions = [
            <RaisedButton
            disabled={this.state.selectedTargetIds.length > 0 ? false : true}  
            className="mr-15"                          
            label="Delete Data"
            primary={true}
            onTouchTap={() => this.handleDeleteTarget()} />,
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />
            ];
        return <Dialog
            className="custom_modal_new_appointment"
            title="RAW TASK ANALYSIS DATA"
            modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
            {this.renderLoading()}
            <div className="table-responsive mt-15">
                    <table className={tableClass}>
                        <thead>
                            <tr>
                                <th width="15%">{<SortingCustom noSort={!RawTADataList.length} setSortColumn={this.setSortColumn} columnName='sessionDate' displayName='Session Date' />}</th>
                                <th width="10%">Time</th>
                                <th width="15%">{<SortingCustom noSort={!RawTADataList.length} setSortColumn={this.setSortColumn} columnName='staffName' displayName='Staff Name' />}</th>
                                <th width="15%">Step Name</th>
                                <th width="15%">Status</th>
                                <th width="15%">Prompt Code</th>
                                <th width="5%">Delete
                                   {/* <div className="table_custom-check">
                                        <Field
                                            name='CheckTargets'
                                            component={renderCheckBox}
                                            onChange={(e) => this.checkAllTargets(e)}
                                            style={stylescss.checkbox}
                                        />
                                        <span>&nbsp;</span>
                                    </div> */}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderaData(RawTADataList)}
                        </tbody>
                    </table>
                </div>
                {RawTADataListMeta && RawTADataListMeta['totalPages'] ?
                    <PaginatorCustom data={RawTADataListMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                }
        </Dialog>;
    }
}

RawDataTAModal = reduxForm({
    form: 'RawDataTAModalForm',
    enableReinitialize: true,
})(RawDataTAModal);


function mapStateToProps(state, ownProps) {

    return {
        loading: state.skillAcquisitionTarget.loading,
        skillAcqCollectedTADataBytTargetId:state.skillAcquisitionTarget.skillAcqCollectedTADataByTargetId !== null ? state.skillAcquisitionTarget.skillAcqCollectedTADataByTargetId : [],
        masterTargetStatusWithoutReady: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.targetStatusWithoutReady : [],
        promptCodeListData: state.patient_prompt_code.promptCodeList !== null ? state.patient_prompt_code.promptCodeList : [],
        allStaffs : state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.allStaffsActiveAndInactive : [],
    }
}

export default connect(mapStateToProps, {
    getSkillAcquisitionCollectedTADataByTargetIDAction,
    deleteSkillAcqCollectedTAData,
    updateSkillAcqCollectedTADataPromtCodeAction,
    updateSkillAcaCollectedTADataAction,
    getPromptCodeList
})(RawDataTAModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/RawDataTAModal.js